<template>
  <sc-page-base
    :title="title"
    :loading="loading">
    <sc-form
      ref="form"
      :form="form"
      :rules="rules"
      :hasStyle="false"
      :buttonsStyle="false"
      @submit="onGetPreInvoices">
      <template slot="fields" slot-scope="{ fields, isValid }">
        <div class="columns">
          <div class="column page-container">
            <sc-pre-invoice-audit-form
              :fields="fields"
              :is-valid="isValid"
              @clearFilters="clearFilters" />

            <sc-pre-invoice-audit-table
              v-if="invoices.length > 0 && !loading"
              :form="form"
              :invoices="invoices"
              @releaseForPayment="onReleaseForPayment"
              @reversePreInvoices="onReversePreInvoices" />
          </div>
        </div>
      </template>
    </sc-form>
  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScPageBase, ScForm, ScToast } from '@intelipost-js/secure-components';

import ScPreInvoiceAuditForm from './components/sc-pre-invoice-audit-form/ScPreInvoiceAuditForm';
import ScPreInvoiceAuditTable from './components/sc-pre-invoice-audit-table/ScPreInvoiceAuditTable';

const { mapState, mapActions } = createNamespacedHelpers('recon/preInvoiceAudit');

export default {
  name: 'page-pre-invoice-audit',
  data() {
    return {
      title: 'Auditoria de Faturas',
    };
  },
  computed: {
    ...mapState([
      'form',
      'invoices',
      'loading',
    ]),
    rules() {
      return {
        warehouses: [
          {
            required: true,
            message: 'Selecione pelo menos um Centro de Distribuição',
          },
        ],
        date_range: [
          {
            required: true,
            message: 'Selecione uma data',
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions([
      'releaseForPayment',
      'getPreinvoicesAudit',
      'reversePreInvoices',
    ]),
    clearFilters() {
      this.$refs.form.clearFilters();
    },
    onGetPreInvoices(filters) {
      this.getPreinvoicesAudit(filters).then((preInvoicesAudit = []) => {
        if (Array.isArray(preInvoicesAudit) && preInvoicesAudit.length === 0) {
          ScToast.danger('Não há registros que atendam aos filtros informados. Tente novamente.');
        }
      });
    },
    onReleaseForPayment(invoices) {
      this.releaseForPayment(invoices).then((ok) => {
        if (ok) {
          ScToast.success('Pagamento liberado com sucesso!');
        }
      });
    },
    onReversePreInvoices(invoices) {
      this.reversePreInvoices(invoices).then((ok) => {
        if (ok) {
          ScToast.success('Estorno realizado com sucesso!');
        }
      });
    },
  },
  components: {
    ScForm,
    ScPageBase,
    ScToast,
    ScPreInvoiceAuditForm,
    ScPreInvoiceAuditTable,
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-audit/PagePreInvoiceAudit.vue